module.exports = __webpack_public_path__ + "img/shop-feature6.aaf287df.png";